import React from 'react';

import ProductSynonymsEditor from '../components/product/synonyms-editor'

class ProductSynonyms extends React.Component {
    render(){
        return (
            <ProductSynonymsEditor/>
        )
    }
}

export default ProductSynonyms


// WEBPACK FOOTER //
// ./src/containers/product-synonyms.js